import { BaseFeaturedSectionRouteStore } from "administration/naki-mobile/stores";

class NakiMobileEmbeddedFeaturedSectionRouteStore extends BaseFeaturedSectionRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default NakiMobileEmbeddedFeaturedSectionRouteStore;
